// @ts-nocheck d7ff7320
import createOfferingListWidget from './createOfferingListWidget';
import { isResponsiveEditor } from '@wix/santa-editor-utils';
export default ({ editorAPI }) =>
  createOfferingListWidget({
    editorAPI,
    isEditorX: isResponsiveEditor(),
  });
